<template>
  <v-menu v-model="menu" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :label="$t('genericFilters.selectHour.label.hour')"
        v-model="hourLabel"
        v-bind="attrs"
        v-on="on"
        :rules="rules"
        hide-details="auto"
        outlined
        readonly
      />
    </template>
    <v-list>
      <v-list-item v-if="preferredHours.length > 0">
        <p class="grey--text mb-0">
          {{ $t('genericFilters.selectHour.label.preferences') }}
        </p>
      </v-list-item>
      <div v-if="preferredHours.length > 0">
        <v-list-item
          v-for="hour in preferredHours"
          @click="handleSelectHour(hour)"
          :key="hour"
        >
          {{ hour }}
        </v-list-item>
      </div>
      <v-divider v-if="preferredHours.length > 0" class="mb-2" />

      <v-list-item>
        <p class="grey--text mb-0">
          {{ $t('genericFilters.selectHour.label.other') }}
        </p>
      </v-list-item>
      <v-list-item
        v-for="hour in otherHours"
        @click="handleSelectHour(hour)"
        :key="hour"
      >
        {{ hour }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import moment from 'moment'
import {
  isToday,
  generateCustomHours,
  generatePreferredHours,
} from '@/util/hoursGeneration'

export default {
  name: 'SelectHour',

  props: {
    data: {
      type: String,
    },

    rules: {
      type: Array,
    },

    date: {
      type: String,
    },

    startDateDelay: {
      type: Number,
      default: 0,
    },

    limitHours: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      menu: false,
      hour: null,
      hourLabel: moment(this.data).format('HH:mm'),
      preferredHours: [],
      otherHours: [],
    }
  },

  watch: {
    data() {
      this.hourLabel = moment(this.data).format('HH:mm')
    },

    date(value) {
      this.checkDateAndGenerateHours(value, this.startDateDelay)
    },
  },

  methods: {
    handleSelectHour(hour) {
      this.hour = hour
      this.hourLabel = hour
      this.$emit('input', this.hour)
    },

    checkDateAndGenerateHours(date, startDelay) {
      const today = isToday(date, startDelay)

      this.otherHours = generateCustomHours(today, 7, 22, this.limitHours)
      this.preferredHours = generatePreferredHours(today, this.limitHours)
    },
  },

  mounted() {
    this.checkDateAndGenerateHours(this.data, this.startDateDelay)
  },
}
</script>

<style scoped>
.v-list {
  height: 240px;
  overflow-y: auto;
}
</style>
